import FastMarquee from "react-fast-marquee";

const EditorialMarquee = ({ items, dark = false }) => (
  <div
    data-testid="editorial-marquee"
    aria-hidden="true"
    className={`overflow-hidden border-y py-5 ${
      dark ? "border-creme/15 bg-mossdeep" : "border-sand/70 bg-parch"
    }`}
  >
    <FastMarquee speed={28} gradient={false}>
      {items.map((item, i) => (
        <span
          key={i}
          className={`mx-8 font-accent text-2xl italic sm:text-3xl ${
            dark ? "text-creme/50" : "text-moss/50"
          }`}
        >
          {item}
          <span className={`ml-16 not-italic ${dark ? "text-sand/60" : "text-rust/50"}`}>·</span>
        </span>
      ))}
    </FastMarquee>
  </div>
);

export default EditorialMarquee;
